<template>
  <div
    :id="id"
    class="rs-inline-form-group"
  >
    <slot />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'RsInlineFormGroup',

  props: {
    id: {
      type: String,
      required: true,
    },
  },
});
</script>

<style lang="scss">
@import '@/styles/_variables.scss';
.rs-inline-form-group {
  border-bottom: solid 1px $border-color;

  .rs-inline-form, .rs-inline-form-toolbar {
    border-bottom: 0;
  }
}
</style>
